// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hover":"_2qbQa","underline":"_127td","headerVariant":"_2t8Cr"};